(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phoenix-find-my-tool"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFinder = (scope) => {
      scope.querySelectorAll('[data-phoenix-finder]').forEach((root) => {
        if (root.dataset.finderInitialized === 'true') return;
        root.dataset.finderInitialized = 'true';

        const form = root.querySelector('[data-finder-form]');
        const results = root.querySelector('[data-finder-results]');
        const resultCards = Array.from(root.querySelectorAll('[data-finder-result-card]'));
        const noResult = root.querySelector('[data-finder-no-result]');
        const resultHeading = results.querySelector('[data-finder-result-heading]');
        const progressCount = root.querySelector('[data-finder-progress-count]');
        const progressBar = root.querySelector('[data-finder-progress-bar]');
        const comparisonCells = Array.from(root.querySelectorAll('[data-finder-compare-key]'));

        if (!form || !results) return;

        const questions = Array.from(form.querySelectorAll('.phoenix-finder__question'));

        const selectedValue = (key) => {
          const selected = form.querySelector(`[data-finder-answer="${key}"]:checked`);
          return selected ? selected.value : '';
        };

        const recommendationKey = (service, usage) => {
          if (service === 'brakes' && usage !== 'daily') return 'diy';
          return 'versatile';
        };

        const updateFinder = () => {
          const vehicle = selectedValue('vehicle');
          const service = selectedValue('service');
          const usage = selectedValue('usage');
          const isDirectMatch = vehicle === 'shop' || vehicle === 'motorcycle';
          const selectedCount = isDirectMatch ? 1 : [vehicle, service, usage].filter(Boolean).length;

          questions.forEach((question, index) => {
            question.hidden = isDirectMatch && index > 0;
          });

          if (progressCount) progressCount.textContent = `${selectedCount} / ${isDirectMatch ? 1 : 3}`;
          if (progressBar) progressBar.style.width = `${isDirectMatch ? 100 : (selectedCount / 3) * 100}%`;

          if (!isDirectMatch && selectedCount < 3) {
            results.hidden = true;
            resultCards.forEach((card) => {
              card.hidden = true;
            });
            results.classList.remove('is-shop-results');
            if (resultHeading) resultHeading.textContent = resultHeading.dataset.defaultHeading;
            comparisonCells.forEach((cell) => cell.classList.remove('is-match'));
            if (noResult) noResult.hidden = true;
            return;
          }

          const resultKeys =
            vehicle === 'shop'
              ? ['shop']
              : [
                  vehicle === 'motorcycle'
                    ? 'motorcycle'
                    : recommendationKey(service, usage)
                ];
          const isShop = vehicle === 'shop';
          let matched = false;

          results.classList.toggle('is-shop-results', isShop);
          if (resultHeading) {
            resultHeading.textContent = isShop
              ? (resultHeading.dataset.shopHeading || resultHeading.dataset.defaultHeading)
              : resultHeading.dataset.defaultHeading;
          }

          resultCards.forEach((card) => {
            const isMatch = resultKeys.includes(card.dataset.resultKey);
            card.hidden = !isMatch;
            if (isMatch) matched = true;
          });

          comparisonCells.forEach((cell) => {
            cell.classList.toggle('is-match', resultKeys.includes(cell.dataset.finderCompareKey));
          });

          if (noResult) noResult.hidden = matched;
          results.hidden = false;
        };

        form.addEventListener('change', (event) => {
          const answer = event.target;
          const isDirectSelection =
            answer.matches('[data-finder-answer="vehicle"]') &&
            (answer.value === 'shop' || answer.value === 'motorcycle');

          if (isDirectSelection) {
            form.querySelectorAll('[data-finder-answer="service"], [data-finder-answer="usage"]').forEach((input) => {
              input.checked = false;
            });
          }

          updateFinder();
        });
        form.addEventListener('reset', () => {
          window.requestAnimationFrame(updateFinder);
        });

        updateFinder();
      });
    };

    initializeFinder(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeFinder(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phoenix-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('phoenix-hero')) {
    customElements.define('phoenix-hero', class PhoenixHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-phoenix-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-phoenix-dot]'));
        this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
        this.speed = Number(this.dataset.speed || 5000);
        this.onVisibilityChange = () => {
          if (document.hidden) {
            this.stop();
          } else {
            this.play();
          }
        };

        this.querySelector('[data-phoenix-prev]')?.addEventListener('click', () => this.previous(true));
        this.querySelector('[data-phoenix-next]')?.addEventListener('click', () => this.next(true));

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideIndex), true));
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.play());
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.goTo(this.current, false);
        this.play();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onBlockSelect = (event) => {
        const slide = event.target.closest('[data-phoenix-slide]');
        if (!slide || !this.contains(slide)) return;
        this.goTo(Number(slide.dataset.slideIndex), true);
      };

      play() {
        this.stop();
        if (!this.autoplay || this.slides.length < 2) return;
        this.timer = window.setInterval(() => this.next(false), this.speed);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      previous(manual) {
        this.goTo((this.current - 1 + this.slides.length) % this.slides.length, manual);
      }

      next(manual) {
        this.goTo((this.current + 1) % this.slides.length, manual);
      }

      goTo(index, manual) {
        if (!this.slides.length) return;
        this.current = Math.max(0, Math.min(index, this.slides.length - 1));

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === this.current;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.toggleAttribute('inert', !isActive);
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.current;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
          dot.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        if (manual) this.play();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phoenix-pdp-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('phoenix-pdp-accordion')) {
    class PhoenixPdpAccordion extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-pdp-accordion-panel]'));
        this.handleToggle = this.handleToggle.bind(this);

        this.panels.forEach((panel) => {
          panel.addEventListener('toggle', this.handleToggle);
        });
      }

      disconnectedCallback() {
        this.panels.forEach((panel) => {
          panel.removeEventListener('toggle', this.handleToggle);
        });
      }

      handleToggle(event) {
        const activePanel = event.currentTarget;

        if (this.dataset.autoClose !== 'true' || !activePanel.open) return;

        this.panels.forEach((panel) => {
          if (panel !== activePanel) panel.open = false;
        });
      }
    }

    customElements.define('phoenix-pdp-accordion', PhoenixPdpAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phoenix-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('phoenix-purchase-faq')) {
    class PhoenixPurchaseFaq extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-purchase-faq-panel]'));
        this.handleToggle = this.handleToggle.bind(this);

        this.panels.forEach((panel) => {
          panel.addEventListener('toggle', this.handleToggle);
        });
      }

      disconnectedCallback() {
        this.panels.forEach((panel) => {
          panel.removeEventListener('toggle', this.handleToggle);
        });
      }

      handleToggle(event) {
        const activePanel = event.currentTarget;

        if (this.dataset.autoClose !== 'true' || !activePanel.open) return;

        this.panels.forEach((panel) => {
          if (panel !== activePanel) panel.open = false;
        });
      }
    }

    customElements.define('phoenix-purchase-faq', PhoenixPurchaseFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phoenix-pdp-related"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bundleRegistry = window.PhoenixPdpBundleRegistry || new Map();
    window.PhoenixPdpBundleRegistry = bundleRegistry;

    const formatMoney = (cents) => {
      if (window.theme?.Currency?.formatMoney) {
        return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
      }

      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
      }).format(Number(cents || 0) / 100);
    };

    const updateBundle = (bundle) => {
      const mainItem = bundle.querySelector('[data-phoenix-bundle-main]');
      const selectedAddons = [
        ...bundle.querySelectorAll('[data-phoenix-bundle-checkbox]:checked:not(:disabled)'),
      ];
      const count = 1 + selectedAddons.length;
      const itemWord = count === 1 ? bundle.dataset.itemLabel : bundle.dataset.itemsLabel;
      const total = selectedAddons.reduce((sum, checkbox) => {
        return sum + Number(checkbox.closest('[data-phoenix-bundle-item]')?.dataset.price || 0);
      }, Number(mainItem?.dataset.price || 0));
      const totalLabel = bundle.querySelector('[data-phoenix-bundle-total-label]');
      const totalValue = bundle.querySelector('[data-phoenix-bundle-total]');
      const submit = bundle.querySelector('[data-phoenix-bundle-submit]');

      if (totalLabel) {
        totalLabel.textContent = `${bundle.dataset.totalLabel} ${count} ${itemWord}`;
      }
      if (totalValue) {
        totalValue.textContent = formatMoney(total);
      }
      if (submit && submit.getAttribute('aria-busy') !== 'true') {
        submit.textContent = `${bundle.dataset.addLabel} ${count} ${itemWord} ${bundle.dataset.toCartLabel}`;
        submit.disabled = mainItem?.dataset.available !== 'true' || !mainItem?.dataset.variantId;
      }
    };

    const initBundle = (bundle) => {
      const sectionId = bundle.closest('[data-section-id]')?.dataset.sectionId;
      const existing = sectionId ? bundleRegistry.get(sectionId) : null;

      if (existing?.bundle === bundle || bundle.dataset.phoenixBundleReady === 'true') return;
      if (existing) existing.destroy();

      const mainItem = bundle.querySelector('[data-phoenix-bundle-main]');
      const mainPrice = bundle.querySelector('[data-phoenix-bundle-main-price]');
      const checkboxes = [...bundle.querySelectorAll('[data-phoenix-bundle-checkbox]')];
      const submit = bundle.querySelector('[data-phoenix-bundle-submit]');
      const status = bundle.querySelector('[data-phoenix-bundle-status]');

      const handleSelection = () => {
        if (status) status.textContent = '';
        updateBundle(bundle);
      };

      const handleVariantChange = (event) => {
        const variant = event.detail?.variant;
        if (!variant) return;
        if (variant.product_id && String(variant.product_id) !== bundle.dataset.productId) return;

        mainItem.dataset.variantId = variant.id || '';
        mainItem.dataset.price = variant.price || 0;
        mainItem.dataset.available = variant.available ? 'true' : 'false';
        if (mainPrice) mainPrice.textContent = formatMoney(variant.price || 0);
        updateBundle(bundle);
      };

      const handleSubmit = async () => {
        if (!submit || submit.disabled || submit.getAttribute('aria-busy') === 'true') return;

        const mainSelect = document.querySelector('main .product-single__form [data-product-select]');
        if (mainSelect?.value) mainItem.dataset.variantId = mainSelect.value;

        const selectedItems = [
          mainItem,
          ...checkboxes
            .filter((checkbox) => checkbox.checked && !checkbox.disabled)
            .map((checkbox) => checkbox.closest('[data-phoenix-bundle-item]')),
        ].filter(Boolean);
        const items = selectedItems.map((item) => ({
          id: item.dataset.variantId,
          quantity: 1,
        }));

        if (items.some((item) => !item.id)) {
          if (status) status.textContent = bundle.dataset.errorLabel;
          return;
        }

        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submit.textContent = bundle.dataset.addingLabel;
        if (status) status.textContent = '';

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });
          const result = await response.json();

          if (!response.ok) {
            throw new Error(result.description || result.message || bundle.dataset.errorLabel);
          }

          if (document.querySelector('#CartDrawer')) {
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          } else {
            window.location.assign(`${root}cart`);
            return;
          }
        } catch (error) {
          if (status) status.textContent = error.message || bundle.dataset.errorLabel;
        } finally {
          submit.removeAttribute('aria-busy');
          updateBundle(bundle);
        }
      };

      checkboxes.forEach((checkbox) => checkbox.addEventListener('change', handleSelection));
      if (submit) submit.addEventListener('click', handleSubmit);
      document.addEventListener('variant:change', handleVariantChange);

      const destroy = () => {
        checkboxes.forEach((checkbox) => checkbox.removeEventListener('change', handleSelection));
        if (submit) submit.removeEventListener('click', handleSubmit);
        document.removeEventListener('variant:change', handleVariantChange);
        if (sectionId) bundleRegistry.delete(sectionId);
      };

      bundle.dataset.phoenixBundleReady = 'true';
      if (sectionId) bundleRegistry.set(sectionId, { bundle, destroy });
      updateBundle(bundle);
    };

    const initRelatedForms = (container = document, attempt = 0) => {
      if (!window.theme || !window.theme.AjaxProduct) {
        if (attempt < 50) {
          window.setTimeout(() => initRelatedForms(container, attempt + 1), 100);
        }
        return;
      }

      container.querySelectorAll('[data-phoenix-related-form]').forEach((form) => {
        if (form.dataset.phoenixAjaxReady === 'true') return;

        new window.theme.AjaxProduct(form, '[data-phoenix-related-submit]');
        form.dataset.phoenixAjaxReady = 'true';
      });
    };

    const initSections = (container = document) => {
      container.querySelectorAll('[data-phoenix-bundle]').forEach(initBundle);
      initRelatedForms(container);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSections());
    } else {
      initSections();
    }

    window.addEventListener('pageshow', () => initSections());

    document.addEventListener('shopify:section:load', (event) => {
      initSections(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sectionId = event.target.dataset.sectionId;
      bundleRegistry.get(sectionId)?.destroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phoenix-pdp-replacement-parts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReplacementForms = (container = document, attempt = 0) => {
      if (!window.theme || !window.theme.AjaxProduct) {
        if (attempt < 50) {
          window.setTimeout(() => initReplacementForms(container, attempt + 1), 100);
        }
        return;
      }

      container.querySelectorAll('[data-phoenix-replacement-form]').forEach((form) => {
        if (form.dataset.phoenixAjaxReady === 'true') return;

        new window.theme.AjaxProduct(form, '[data-phoenix-replacement-submit]');
        form.dataset.phoenixAjaxReady = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initReplacementForms());
    } else {
      initReplacementForms();
    }

    window.addEventListener('pageshow', () => initReplacementForms());
    document.addEventListener('shopify:section:load', (event) => initReplacementForms(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
